import React from "react";
import { Container, Col, Row } from "react-bootstrap";
import FadeInAnimation from "../../components/animations/FadeInAnimation";
import RisingInAnimation from "../../components/animations/RisingInAnimation";

const DonateScreen = () => {
  const handleDownload = () => {
    const filename = "LOYM_tax_exempt.tiff";
    const url = "/LOYM_tax_exempt.tiff";

    const link = document.createElement("a");
    link.href = url;
    link.download = filename;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  return (
    <Container>
      <Row className="justify-content-md-center">
        <Col sm={12} lg={6}>
          <h1 className="header">Why donate?</h1>
          <br />
          <FadeInAnimation>
            <p className="text-box" style={{ whiteSpace: "pre-line" }}>
              Love On You Mommy Ministry is a 501(c)(3) tax-exempt nonprofit
              organization dedicated to engaging, encouraging, and empowering
              moms. {" \n\n "} Your generosity helps us continue our mission of
              serving moms through meaningful connections, faith-based
              encouragement, and community outreach. {" \n\n "} Want to verify
              our nonprofit status? {" \n\n "}Love On You Mommy Ministry's
              nonprofit information and available tax filings can be viewed
              through the links below.
              {" \n\n "}
              <a href="https://projects.propublica.org/nonprofits/organizations/844434037">
                View our nonprofit profile and tax filings
              </a>
              {" \n\n "}
              <a href="https://apps.irs.gov/app/eos/">
                Verify our status through the IRS
              </a>
            </p>
          </FadeInAnimation>
        </Col>
      </Row>
      <br />
      <br />
      <hr />
      <Row className="justify-content-md-center">
        <Col sm={12} lg={6}>
          <br />
          <h1 className="header">Click on image to donate</h1>
          <FadeInAnimation>
            <a
              href="https://www.zeffy.com/en-US/donation-form/donate-to-make-a-difference-1979"
              target="blank"
            >
              <img src="/img/loym_donate.jpg" width="100%" />
            </a>
          </FadeInAnimation>
        </Col>
      </Row>
      <br />
      <br />
      <hr />
      <br />
      <br />
      <RisingInAnimation>
        <Row className="justify-content-md-center">
          <Col xs={12} md={5}>
            <br />
            <p className="text-box">
              Please click{" "}
              <a onClick={handleDownload} className="link">
                here
              </a>{" "}
              to download our 501 c 3 tax e-exempt determination letter
            </p>
          </Col>
          <Col xs={12} md={{ span: 5, offset: 2 }}>
            <br />
            <p className="text-box">
              Our annual information return (IRS Form 990) is available upon
              request via email to loveonyoumommy@gmail.com. Connect to us
            </p>
          </Col>
        </Row>
      </RisingInAnimation>
    </Container>
  );
};

export default DonateScreen;
